<template>
  <div>
      <h2>Logs</h2>
      <div v-if="webhooks"><b>Webhooks</b> <itable :tabledata="$store.state.items.webhooks" /></div>
     
      <div v-if="email"><b>Emails</b> <itable :tabledata="$store.state.items.email" /></div>
  </div>
</template>
<script>
export default {
  data() {
    return { logs: {}, email: false, webhooks: false };
  },
  created() {
    this.logs.webhooks = this.$store.dispatch("query", {
      collection: "webhooks",
      type: "list",
    }).then(x => {this.webhooks = true; return x});
    this.logs.email = this.$store.dispatch("query", {
      collection: "email",
      type: "list",
    }).then(x => {this.email = true; return JSON.parse(JSON.stringify(x))});
  },
};
</script>